import React from 'react';
const ProgressBar = (props) => {
    const { bgcolor, completed,heading,lightColor } = props;
    
  


    const containerStyles = {
      height: 13,
      width: '88%',
      backgroundColor: "#e0e0de",
      borderRadius: 50,
      margin: 8
    }
  
    const fillerStyles = {
      height: '100%',
      width: `${completed}%`,
      backgroundColor: bgcolor,
      borderRadius: 'inherit',
      textAlign: 'right'
    }
  
    const labelStyles = {
      padding: 5,
      color: 'white',
      fontWeight: 'bold'
    }

    const completeCount={
border:"2px solid "+bgcolor,
borderRadius:"10px",
width:"40px",
height:"25px",
textAlign:"center",
color:bgcolor,
fontWeight:"bold",
backgroundColor:lightColor,
marginRight:"0px"
    }
  
    return (<>
      <h4 style={{color:"#767676"}}>{heading}</h4>
      <div className="d-flex justify-content-between">
      <div style={containerStyles}>
        <div style={fillerStyles}>
          
        </div>
      </div>
        <div style={completeCount}>
               {completed}%
        </div>
      </div>
      </>
    );
  };
  
  export default ProgressBar;